class CartDiscountField extends HTMLElement {
  constructor() {
    super();
    this.submitButton = this.querySelector("#sc-discount__submit");
    this.codeInput = this.querySelector("#code");
    this.warningMessage = this.querySelector(".sc-message--warning");
    this.loader = this.querySelector(".sc_code-loading");
    this.shopifyClient = ShopifyStorefrontAPIClient.createStorefrontApiClient({
      storeDomain: "http://sistaco-europe.myshopify.com",
      apiVersion: "2025-01",
      publicAccessToken: "23edeceb3948b04753e080a9d4ef5539",
      retries: 3,
    });

    this.boundApplyDiscount = this.applyDiscount.bind(this);
    this.boundRemoveDiscount = this.removeDiscount.bind(this);
    this.boundHandleProductAdded = this.handleProductAdded.bind(this);
    this.boundhandleKeyDown = this.handleKeyDown.bind(this);
    this.boundHandleCartRefresh = () => {
      this.classList.remove("disabled-discount-field");
    };
  }

  connectedCallback() {
    this.codesArray = Array.from(
      document.querySelectorAll(
        '.code-name[data-discount-type="discount_code"]'
      )
    ).map((element) => element.getAttribute("title"));

    this.codeRemovers = this.querySelectorAll(".code-remover");
    this.codeInput.addEventListener("keydown", this.boundhandleKeyDown);
    this.submitButton.addEventListener("click", this.boundApplyDiscount);
    this.codeRemovers.forEach((remover) => {
      remover.addEventListener("click", this.boundRemoveDiscount);
    });

    //Theme specific Event Listeners
    document.addEventListener("cart:refresh", this.boundHandleCartRefresh);
    document.addEventListener("product:added", this.boundHandleProductAdded);
    if(this.classList.contains('scDiscount__container--disabled')){
      this.clearDiscounts();
    }
  }

  disconnectedCallback() {
    this.codeInput.removeEventListener("keydown", this.boundhandleKeyDown);
    this.submitButton.removeEventListener("click", this.boundApplyDiscount);
    this.codeRemovers.forEach((remover) => {
      remover.removeEventListener("click", this.boundRemoveDiscount);
    });

    document.removeEventListener("cart:refresh", this.boundHandleCartRefresh);
    document.removeEventListener("product:added", this.boundHandleProductAdded);
  }

  handleKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.boundApplyDiscount();
    }
  }

  handleProductAdded(event) {
    if (
      event.detail.variant.properties?._discountCode &&
      event.detail.variant.properties?._discountCodeProduct
    ) {
      const discountCode = event.detail.variant.properties._discountCode;
      const discountCodeProduct = parseInt(
        event.detail.variant.properties._discountCodeProduct,
        10
      );

      this.applyDiscount(event, discountCode, discountCodeProduct);
    }
  }

  removeDiscount(e) {
    this.classList.add("disabled-discount-field");
    const removerButton = e.target.closest(".code-remover");
    if (!removerButton) {
      console.error("Could not find the code remover button");
      return;
    }
    const code = removerButton.getAttribute("title");

    console.log("Removing discount", code);
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        this.discountRemover.bind(this)(code, cart);
      });
  }

  async applyDiscount(event, discountCode, discountProduct) {
    console.log("Applying discount");
    this.submitButton.style.display = "none";
    this.loader.style.display = "block";
    const code = discountCode || this.codeInput.value;
    if (!code) {
      console.error("Discount code cannot be empty");
      this.submitButton.style.display = "block";
      this.loader.style.display = "none";
      return;
    }
    await fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const discountMatch = window.discountProduct?.filter(
          (product) => product.discountCode.toLowerCase() === code.toLowerCase()
        );

        const isParentProductInCart = cart.items.some(
          (item) => item.product_id === discountMatch[0]?.parentProductId);
        const noParentProduct =  discountMatch[0]?.noParentProduct;
        const isFreeProductInCart =
          discountMatch &&
          discountMatch.length > 0 &&
          cart.items.some(
            (item) => item.variant_id === discountMatch[0].variantId
          );

        if (discountProduct) {
          var isDiscountProductInCart = cart.items.some(
            (item) => item.variant_id === discountProduct
          );
        }

        if (!isDiscountProductInCart && discountProduct) {
          this.productAdder(discountProduct, code, cart);
        } else if (
          discountMatch &&
          discountMatch.length > 0 &&
          discountMatch[0].variantId &&
          !isFreeProductInCart && (isParentProductInCart || noParentProduct)
        ) {
          this.productAdder(discountMatch[0].variantId, code, cart);
        } else {
          this.discountApplicator.bind(this)(code, cart);
        }
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }

  async productAdder(variantId, code, cart) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              _discountCode: code,
              _discountCodeProduct: `${variantId}`,
              _buyXGetY: "true",
            },
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Product added to cart:", data);
        this.discountApplicator.bind(this)(code, cart);
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  }

  async discountApplicator(code, cart) {
    code = code.trim();

    const mutation = `
            mutation ApplyDiscount($cartId: ID!, $discountCodes: [String!]!) {
              cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                cart {
                  id
                  discountCodes {
                    applicable
                    code
                  }
                }
                userErrors {
                  field
                  message
                }
              }
            }
          `;

    const normalizedCode = code.trim().toLowerCase();
    const discountsToRemove = this.codesArray.filter((existingCode) =>
      existingCode.toLowerCase() !== normalizedCode
    );

    for (const discount of discountsToRemove) {
      await this.discountRemover(discount, cart);
    }
    this.codesArray = [code];

    const variables = {
      cartId: `gid://shopify/Cart/${cart.token}`,
      discountCodes: [...this.codesArray],
    };

    try {
      const { data, errors, extensions } = await this.shopifyClient.request(
        mutation,
        { variables: variables }
      );
      console.log("Discount applied:", data);

      this.submitButton.style.display = "block";
      this.loader.style.display = "none";
      if (
        data.cartDiscountCodesUpdate.userErrors &&
        data.cartDiscountCodesUpdate.userErrors.length > 0
      ) {
        this.warningMessage.style.display = "block";
      } else if (
        data.cartDiscountCodesUpdate.cart.discountCodes &&
        data.cartDiscountCodesUpdate.cart.discountCodes.length > 0
      ) {
        const appliedCode = code ? code.toLowerCase() : "";
        const foundDiscountEntry =
          data.cartDiscountCodesUpdate.cart.discountCodes.find(
            (discount) =>
              discount.code && discount.code.toLowerCase() === appliedCode
          );

        if (foundDiscountEntry && !foundDiscountEntry.applicable) {
          this.warningMessage.style.display = "block";
        } else {
          this.warningMessage.style.display = "none";
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );
        }
      } else {
        this.warningMessage.style.display = "none";
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
      }
    } catch (error) {
      console.error("Error updating order:", error);
    }
  }

  async discountRemover(code, cart) {
    const mutation = `
            mutation ApplyDiscount($cartId: ID!, $discountCodes: [String!]!) {
              cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                cart {
                  id
                  discountCodes {
                    applicable
                    code
                  }
                }
                userErrors {
                  field
                  message
                }
              }
            }
          `;

    if (code) {
      this.codesArray = this.codesArray.filter((item) => item !== code);
    }

    const variables = {
      cartId: `gid://shopify/Cart/${cart.token}`,
      discountCodes: [...this.codesArray],
    };

    try {
      const { data, errors, extensions } = await this.shopifyClient.request(
        mutation,
        { variables: variables }
      );

      if (
        cart.items.some(
          (item) =>
            item.properties._discountCode?.toLowerCase() ===
              code?.toLowerCase() && item.properties._buyXGetY === "true"
        )
      ) {
        const data = await fetch("/cart.js");
        cart = await data.json();
        const item = cart.items.find(
          (item) =>
            item.properties._discountCode?.toLowerCase() ===
              code?.toLowerCase() && item.properties._buyXGetY === "true"
        );
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Product removed from cart:", data);
          })
          .finally(() => {
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
              })
            );
          })
          .catch((error) => {
            console.error("Error removing product from cart:", error);
          });
      }
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
    } catch (error) {
      console.error("Error updating order:", error);
    }
  }

  async clearDiscounts() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        if(cart.discount_codes.length > 0){
          this.codesArray = [];
          this.discountRemover.bind(this)(null, cart);
        }
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }
}

customElements.define("cart-discount-field", CartDiscountField);